let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("e8civ")).then(() => parcelRequire('iCM8K'));